module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/1/5-314aaa81c88aa3f7269057792b51c2da.jpg";